/** 
*@author Mustafa Omran 
*/

import { Component } from '@angular/core';
import { MegaMenuService } from './../../../services/Home/mega-menu.service';

@Component({
  selector: 'mega-menu',
  templateUrl: './mega-menu.component.html',
  styleUrls: ['./mega-menu.component.css'],
  providers: [
    MegaMenuService,
  ]
})


export class MegaMenuComponent {

  public errors: any;
  public megaMenu: any;

  constructor(
    public megaMenuService: MegaMenuService,
  ) {

  }
  public ngOnInit() {
    this.getMegaMenu();
  }

  /**
   * get mega menu !
   */
  public getMegaMenu() {
    this.megaMenuService.getMegaMenu().subscribe(
      (data) => {
        this.megaMenu = data.megaMenu;
      },
      (errors) => {
        this.errors = errors;
      }
    );

  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/MartMax/components/home-page/mega-menu/mega-menu.component.ts